<template>
    <WatsonOrganismContent
        class="content-container"
        :content="content"
    />
</template>

<script setup>
import WatsonOrganismContent from '@organisms/content/watson-organism-content.vue';

defineProps({
    page: {
        type: Object,
        required: true,
    },
    content: {
        type: Array,
        required: true,
    },
});
</script>

<style lang="scss" scoped>
@use 'content-index';
</style>
